import {Controller} from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ["filterForm", "orderInput", "descendingInput"]
  static values = {order: String, descending: Boolean}

  #order = "";
  #descending = null;
  #filterForm = null
  #table;

  initialize() {
    this.setColumnWidths = this.setColumnWidths.bind(this)
  }

  connect() {
    this.#table = this.element.querySelector(".data__table");
    this.#order = this.orderValue;
    this.#descending = this.descendingValue;
    this.#filterForm = this.element.closest("form")
    this.#updateOrderInputs();
    requestAnimationFrame(() => {
      this.setColumnWidths()
    })
  }

  setColumnWidths() {
    let colWidths = {}
    let cells = this.element.querySelectorAll(".data__cell, .header__column")
    cells.forEach(cell => {
      cell.classList.forEach(cls => {
        const match = cls.match(/^col-(\d+)$/)
        if (match) {
          const colIndex = match[1]
          const cellWidth = this.measureCellContentWidth(cell)
          if (!colWidths[colIndex] || cellWidth > colWidths[colIndex]) {
            colWidths[colIndex] = cellWidth
          }
        }
      })
    })
    let existingStyle = document.head.querySelector("style[data-dynamic-column-styles]")
    let style = existingStyle
    if (!existingStyle) {
      style = document.createElement("style")
      style.dataset.dynamicColumnStyles = "true"
    }
    let css = ""
    Object.entries(colWidths).forEach(([colIndex, width]) => {
      css += `.col-${colIndex} { width: ${width}px; }\n`
    })
    style.innerHTML = css
    if (!existingStyle) {
      document.head.appendChild(style)
    }
  }

  measureCellContentWidth(cell) {
    // Clone cell content in a temporary span to measure rendered width
    const clone = document.createElement("div")
    clone.classList.add("table-cell", "shrink-0")
    clone.style.visibility = "hidden"
    clone.style.position = "absolute"
    clone.style.whiteSpace = "nowrap"
    clone.innerHTML = cell.innerHTML

    document.body.appendChild(clone)
    const width = clone.offsetWidth + 48
    document.body.removeChild(clone)

    return width
  }


  sortColumn(e) {
    this.setOrder(e.params.sortColumn)
  }

  setOrder(order) {
    if (this.#order != order) {
      this.#order = order;
      this.#descending = false;
    } else {
      switch (this.#descending) {
        case null:
          this.#descending = false;
          break;
        case true:
          this.#descending = null;
          break;
        case false:
          this.#descending = true;
          break;
      }
      if (this.#descending === null)
        this.#order = null;
    }
    this.#updateOrderInputs();
    this.#submitFilterForm();
  }

  #updateOrderInputs() {
    this.orderInputTarget.value = this.#order;
    this.descendingInputTarget.value = this.#descending;
  }

  #submitFilterForm() {
    this.#filterForm.requestSubmit();
  }
}
